import axios from "axios";
import type { FinancialData } from "@/pages/management/technicalsheets/technicalsheet/services/dto/FinancialData.ts";

export async function getFinancialData(
  domainId: string,
  siteId: string,
  date: string,
  valuationId: string,
  componentIds: string[],
): Promise<FinancialData | undefined> {
  if (componentIds.length == 0) return;
  //  Setting paramsSerializer.indexes to null writes repeated query params like so:
  //  /path?a=1&a=2
  // Instead of the default behavior which inserts empty brackets like so:
  // /path?a[]=1&a[]=2
  const { data } = await axios.get<FinancialData>(
    `/api/materialsmanagement/components/financialdata/domain/${domainId}/site/${siteId}`,
    {
      params: { componentId: componentIds, valuationId, date },
      paramsSerializer: { indexes: null },
    },
  );
  return data;
}
